module.exports = "<tb-data-group-overview></tb-data-group-overview>\n";